import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import '../styles/cultural-platform.css';

const HeaderModern = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleTabNavigation = (tabName) => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      const tabElement = document.querySelector(`[data-testid="${tabName}-tab"]`);
      if (tabElement) {
        tabElement.click();
      }
    } else {
      navigate('/', { state: { activeTab: tabName } });
    }
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Arts', path: '/', isTab: true, tabName: 'arts' },
    { name: 'Films', path: '/', isTab: true, tabName: 'films' },
    { name: 'Culture', path: '/', isTab: true, tabName: 'culture' },
    { name: 'Leadership', path: '/team' },
    { name: 'Our Latest Release', path: '/latest-release' },
    { name: 'Contact', path: '/contact' }
  ];

  const renderNavItem = (item, index) => {
    if (item.isTab) {
      return (
        <button
          key={index}
          onClick={() => handleTabNavigation(item.tabName)}
          className="cultural-nav-link"
          data-testid={`nav-${item.tabName}-link`}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            padding: 0
          }}
        >
          {item.name}
        </button>
      );
    }
    return (
      <Link
        key={index}
        to={item.path}
        className={`cultural-nav-link ${location.pathname === item.path ? 'active' : ''}`}
        data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}-link`}
        onClick={() => setMobileMenuOpen(false)}
      >
        {item.name}
      </Link>
    );
  };

  return (
    <header className="cultural-nav" data-testid="main-header" style={{
      height: '80px',
      borderBottom: '1px solid var(--surface-dark)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 32px'
      }}>
        {/* Left Section - Logo + Site Name */}
        <Link to="/" className="cultural-logo" data-testid="logo-link" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '14px',
          textDecoration: 'none',
          color: 'var(--text-primary)'
        }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_soft-influence-1/artifacts/g6p6wvoo_Copy%20of%20Copy%20of%20Copy%20of%20PROJECT%20SOFT%20POWER%20LOGO.PNG"
            alt="Project Soft Power Logo"
            style={{ 
              height: '64px',
              width: 'auto'
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{
              fontFamily: 'var(--font-primary)',
              fontSize: '18px',
              fontWeight: '500',
              lineHeight: '1.2'
            }}>
              Project Soft Power
            </span>
            <span style={{
              fontSize: '10px',
              color: 'var(--text-secondary)',
              letterSpacing: '0.5px',
              textTransform: 'uppercase'
            }}>
              Arts · Films · Culture
            </span>
          </div>
        </Link>

        {/* Right Section - All Navigation Items */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '28px'
        }}>
          <nav className="desktop-nav" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            {navItems.map((item, index) => renderNavItem(item, index))}
            <Link to="/contact" data-testid="nav-join-btn">
              <button className="cultural-cta" style={{
                padding: '10px 24px',
                fontSize: '13px',
                fontWeight: '500',
                marginLeft: '8px'
              }}>
                JOIN NOW
              </button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px'
            }}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div style={{
          position: 'fixed',
          top: '80px',
          left: 0,
          right: 0,
          bottom: 0,
          background: 'var(--primary-white)',
          zIndex: 999,
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {navItems.map((item, index) => (
            <div key={index} style={{ borderBottom: '1px solid var(--surface-dark)', paddingBottom: '12px' }}>
              {renderNavItem(item, index)}
            </div>
          ))}
          <Link 
            to="/contact" 
            onClick={() => setMobileMenuOpen(false)}
            style={{ marginTop: '16px' }}
          >
            <button className="cultural-cta" style={{ width: '100%' }}>
              JOIN NOW
            </button>
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 1100px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default HeaderModern;
